const AUTH_ROUTE = `/api/users`;

export const SIGNUP_ROUTE = `${AUTH_ROUTE}/auth/register`;
export const LOGIN_ROUTE = `${AUTH_ROUTE}/auth/login`;
export const GET_USER_ROUTE = `${AUTH_ROUTE}/auth/getUser`;
export const LOGOUT_ROUTE = `${AUTH_ROUTE}/auth/logout`;

export const SEND_OTP_ROUTE = `${AUTH_ROUTE}/otp/sendotp`;
export const VERIFY_OTP_ROUTE = `${AUTH_ROUTE}/otp/verifyotp`;

const CATEGORY_ROUTE = `/api/admin/categories`;
export const GET_ALL_CATEGORIES = `${CATEGORY_ROUTE}/getCategories`;
export const GET_CATEGORY_BY_ID = `api/users/category/getCategoryById/`;

const PRODUCT_ROUTE = `/api/users/products`;
export const GET_ALL_PRODUCTS = `${PRODUCT_ROUTE}/getAllProducts`;
export const GET_PRODUCT_BY_ID = `${PRODUCT_ROUTE}/getProductById/`;
export const GET_PRODUCTS_BY_CATEGORY = `${PRODUCT_ROUTE}/getProductByCategory/`
export const GET_FEATURED_PRODUCTS = `${PRODUCT_ROUTE}/getFeaturedProducts`;

const TEAM_ROUTE = `/api/users/team`;
export const GET_ALL_MEMBERS = `${TEAM_ROUTE}/getAllTeamMembers`;

const INQUIRY_ROUTE = `/api/users/queries`;
export const CREATE_INQUIRY = `${INQUIRY_ROUTE}/createQuery`;

const REVIEW_ROUTE = `/api/users/reviews`;
export const CREATE_REVIEW = `${REVIEW_ROUTE}/create`;
export const GET_PRODUCT_REVIEWS = `${REVIEW_ROUTE}/product/`;
export const UPDATE_REVIEW = `${REVIEW_ROUTE}/update/`;
export const DELETE_REVIEW = `${REVIEW_ROUTE}/delete/`;

export const UPDATE_USER_ROUTE = `${AUTH_ROUTE}/auth/updateUser`;
export const UPLOAD_PROFILE_IMAGE_ROUTE = `${AUTH_ROUTE}/auth/uploadProfileImage`;

